export interface BannerItem {
  text: string;
  image: string;
}

export interface BannerInterface {
  title: string;
  items: Array<BannerItem>;
}

const english: BannerInterface = {
  title: 'One Place For All Your Crypto & Finance Needs',
  items: [
    {
      text: 'Free transactions, low fees, and a variety of assets to choose from.',
      image: 'banner-1',
    },
    {
      text: 'Instantly send Euro or crypto to friends on Ka.app — no fees, no delays.',
      image: 'banner-2',
    },
    {
      text: 'Pay, spend and manage your money — all in one account.',
      image: 'banner-3',
    },
    {
      text: 'Safe from cyber attacks, internal collusion, and human error with Fireblocks’ multi-layer system.',
      image: 'banner-4',
    },
  ],
};

const italian: BannerInterface = {
  title: 'Un Unico Posto Per Tutte Le Tue Necessità Crypto E Finanziarie',
  items: [
    {
      text: 'Transazioni veloci, basse commissioni, ed una varietà di asset da sceglier',
      image: 'banner-1',
    },
    {
      text: 'Invia istantaneamente crypto o Euro ad amici su Ka.app - zero commissioni zero ritardi',
      image: 'banner-2',
    },
    {
      text: 'Paga, spendi e gestisci i tuoi soldi tutto in un unico account',
      image: 'banner-3',
    },
    {
      text: 'Al sicuro da cyber-attacchi, collusione interna ed errori umani con il sistema multilayer di Fireblocks',
      image: 'banner-4',
    },
  ],
};

const bulgarian: BannerInterface = {
  title: 'Единственото Място За Всички Твои Крипто & Финансови Нужди',
  items: [
    {
      text: 'Бирзи транзакции, ниски такси, и разнообразие от асети от които да избереш',
      image: 'banner-1',
    },
    {
      text: 'Мигновено изпращай Евро или крипто на приятели в Ка.арр - без такси, без закснения',
      image: 'banner-2',
    },
    {
      text: 'Плащай, харчи и управлявай твоите пари - всичко от един акаунт',
      image: 'banner-3',
    },
    {
      text: 'Защитен от кибератаки, грешки и втрешни проблеми с технологията на Fireblocks.',
      image: 'banner-4',
    },
  ],
};

export const data = {
  en: {...english},
  gb: {...bulgarian},
  it: {...italian},
};
